module.exports = __webpack_public_path__ + "static/media/financialIcon.76c492b9.svg";